import { createFileRoute } from '@tanstack/react-router';

import { ExerciseReviewQueueScreen } from '@/features/exercises/components/ExerciseReviewQueueScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/exercises/review-queue')({
  beforeLoad: () => {
    requirePermission('engagement:review');
  },
  component: ExerciseReviewQueueRoute,
  staticData: { crumb: 'Review exercise' },
});

function ExerciseReviewQueueRoute() {
  return <ExerciseReviewQueueScreen surface="clinical" />;
}
